import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import { NAOption } from "../../Designer/CreateStyle/data";

export const fabricCategoriesObj = {
	KNIT: { name: "KNIT", key: "KNIT" },
	WOVEN: { name: "WOVEN", key: "WOVEN" },
};

export const fabricCategoryColumn = {
	name: "Fabric Category",
	key: "fabric_category",
	editable: true,
	input_type: inputTypes.SELECT.key,
	data_type: datatypes.STRING.key,
	constraints: { NOTNULL: true, DISPLAY: true },
	[selectOptionsKeyName]: {
		type: arrType,
		list: Object.values(fabricCategoriesObj),
	},
};

export const fabricTypeDropdowns = [
	{ key: "SOLID", name: "SOLID", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ key: "YARN DYED STRIPE", name: "YARN DYED STRIPE", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ key: "ROTARY PRINT", name: "ROTARY PRINT", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ key: "DIGITAL PRINT", name: "DIGITAL PRINT", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ key: "YARN DYED CHECKS", name: "YARN DYED CHECKS", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ key: "YARN DYED CHAMBRAY", name: "YARN DYED CHAMBRAY", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ key: "EMBROIDERY", name: "EMBROIDERY", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ key: "SOLID", name: "SOLID", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ key: "YARN DYED", name: "YARN DYED", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ key: "ROTARY PRINT", name: "ROTARY PRINT", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ key: "DIGITAL PRINT", name: "DIGITAL PRINT", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ key: "EMBROIDERY", name: "EMBROIDERY", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ key: "MELANGE", name: "MELANGE", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
];

// convert these to weaveKnitDropdowns name key values to capital letters

export const weaveKnitDropdowns = [
	{ name: "SINGLE JERSEY", key: "SINGLE JERSEY", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "INTERLOCK", key: "INTERLOCK", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "SINGLE TUCK PIQUE", key: "SINGLE TUCK PIQUE", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "DOUBLE TUCK PIQUE", key: "DOUBLE TUCK PIQUE", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "2T TERRY", key: "2T TERRY", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "3T TERRY", key: "3T TERRY", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "PLAITED INTERLOCK", key: "PLAITED INTERLOCK", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "FOMA INTERLOCK", key: "FOMA INTERLOCK", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "JAQUARD", key: "JAQUARD", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "TRANSFER JAQUARD", key: "TRANSFER JAQUARD", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "TRIPLE TUCK PIQUE", key: "TRIPLE TUCK PIQUE", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "1X1 RIB", key: "1X1 RIB", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "2X2 RIB", key: "2X2 RIB", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "2X1 RIB", key: "2X1 RIB", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "3X1 RIB", key: "3X1 RIB", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "4X2 RIB", key: "4X2 RIB", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "POINTELLE", key: "POINTELLE", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "PURL", key: "PURL", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "SEERSUCKER", key: "SEERSUCKER", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "CREPE", key: "CREPE", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "QUILT", key: "QUILT", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "PLAIN", key: "PLAIN", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "DOBBI", key: "DOBBI", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "JACQUARD", key: "JACQUARD", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "TWILL", key: "TWILL", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "OXFORD", key: "OXFORD", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "2/1 TWILL", key: "2/1 TWILL", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "2/2 TWILL", key: "2/2 TWILL", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "3/1 TWILL", key: "3/1 TWILL", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "3/2 TWILL", key: "3/2 TWILL", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "CAVALRY TWILL", key: "CAVALRY TWILL", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "SATIN", key: "SATIN", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "HERRING BONE", key: "HERRING BONE", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "COURDROY", key: "COURDROY", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "CORD", key: "CORD", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "BASKET", key: "BASKET", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "MATT", key: "MATT", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "GEORGETTE", key: "GEORGETTE", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "CREPE", key: "CREPE", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "CRINKLE", key: "CRINKLE", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "SEERSUCKER", key: "SEERSUCKER", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "DOUBLE CLOTH", key: "DOUBLE CLOTH", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "MUSLIN", key: "MUSLIN", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "LACE", key: "LACE", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "PIQUE", key: "PIQUE", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "FLAT KNIT", key: "FLAT KNIT", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "FLEECE", key: "FLEECE", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "TEXTURE", key: "TEXTURE", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "WAFFLE", key: "WAFFLE", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "TWILL JACQUARD", key: "TWILL JACQUARD", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "VELVET", key: "VELVET", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "FLAT KNIT JACQUARD", key: "FLAT KNIT JACQUARD", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "FLAT KNIT CABLE", key: "FLAT KNIT CABLE", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "OTTOMAN", key: "OTTOMAN", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
];
export const finishDropdowns = [
	{ name: "PEACH FINISH", key: "PEACH FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "ANTI BACTERIAL FINISH", key: "ANTI BACTERIAL FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{
		name: "ANTI MICROBIAL/ANTI ODOUR FINISH",
		key: "ANTI MICROBIAL/ANTI ODOUR FINISH",
		[fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key,
	},
	{ name: "STAIN REPELLANT FINISH", key: "STAIN REPELLANT FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "STAY BLACK FINISH", key: "STAY BLACK FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "MERCERIZED FINISH", key: "MERCERIZED FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "SANFORIZED FINISH", key: "SANFORIZED FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "ETI FINISH", key: "ETI FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "LIQUID AMMONIA FINISH", key: "LIQUID AMMONIA FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "LA+ETI FINISH", key: "LA+ETI FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "SAND WASH FINISH", key: "SAND WASH FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "ANTI STATIC FINISH", key: "ANTI STATIC FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "WICKING FINISH", key: "WICKING FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "COOL & COMFORT FINISH", key: "COOL & COMFORT FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "PU COATING FINISH", key: "PU COATING FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "BRUSHED FINISH", key: "BRUSHED FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "ANTI PILLING FINISH", key: "ANTI PILLING FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "CALENDARING FINISH", key: "CALENDARING FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "CRUSH FINISH", key: "CRUSH FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },
	{ name: "PEACH FINISH", key: "PEACH FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "ANTI BACTERIAL FINISH", key: "ANTI BACTERIAL FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{
		name: "ANTI MICROBIAL/ANTI ODOUR FINISH",
		key: "ANTI MICROBIAL/ANTI ODOUR FINISH",
		[fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key,
	},
	{ name: "STAIN REPELLANT FINISH", key: "STAIN REPELLANT FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "STAY BLACK FINISH", key: "STAY BLACK FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "MERCERIZED FINISH", key: "MERCERIZED FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "SANFORIZED FINISH", key: "SANFORIZED FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "ETI FINISH", key: "ETI FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "LIQUID AMMONIA FINISH", key: "LIQUID AMMONIA FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "LA+ETI FINISH", key: "LA+ETI FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "SAND WASH FINISH", key: "SAND WASH FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "ANTI STATIC FINISH", key: "ANTI STATIC FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "WICKING FINISH", key: "WICKING FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "COOL & COMFORT FINISH", key: "COOL & COMFORT FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "PU COATING FINISH", key: "PU COATING FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "BRUSHED FINISH", key: "BRUSHED FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "ANTI PILLING FINISH", key: "ANTI PILLING FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "CALENDARING FINISH", key: "CALENDARING FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "CRUSH FINISH", key: "CRUSH FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "GOLD FINISH", key: "GOLD FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "ENZYME SILICONE FINISH", key: "ENZYME SILICONE FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "BIO FINISH", key: "BIO FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "NORMAL FINISH", key: "NORMAL FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "NORMAL FINISH", key: "NORMAL FINISH", [fabricCategoryColumn.key]: fabricCategoriesObj.WOVEN.key },

	{ name: "DOUBLE MERCERIZED", key: "DOUBLE MERCERIZED", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
	{ name: "GASSED MERCERIZED", key: "GASSED MERCERIZED", [fabricCategoryColumn.key]: fabricCategoriesObj.KNIT.key },
];

export const fabricMasterColumnsObj = {
	type: {
		name: "Type",
		key: "type",
		input_type: inputTypes.SELECT.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: true, DISPLAY: true },
		[selectOptionsKeyName]: {
			type: arrType,
			list: [],
		},
	},
	weave_knit: {
		name: "Weave/Knit",
		key: "weave_knit",
		input_type: inputTypes.SELECT.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: true, DISPLAY: true },
		[selectOptionsKeyName]: {
			type: arrType,
			list: [],
		},
	},
	finish: {
		name: "Finish",
		key: "finish",
		input_type: inputTypes.SELECT.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: true, DISPLAY: true },
		[selectOptionsKeyName]: {
			type: arrType,
			list: [],
		},
	},
	sort_no: {
		name: "Sort No",
		key: "sort_no",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
		default_value: NAOption,
	},
};

export const countUnitDropdowns = [
	{ name: "s", key: "s" },
	{ name: "sf", key: "sf" },
	{ name: "dn", key: "dn" },
	{ name: "lea", key: "lea" },
	{ name: "Ne", key: "Ne" },
	{ name: "Nm", key: "Nm" },
];

export const knitCountColumn = {
	name: "Count",
	key: "knit_count",
	editable: true,
	data_type: datatypes.STRING.key,
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: true, DISPLAY: true },
};
export const wovencountWarpColumn = {
	name: "Count",
	key: "woven_count_warp",
	editable: true,
	data_type: datatypes.STRING.key,
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: true, DISPLAY: true },
};
export const wovencountweftColumn = {
	name: "Count",
	key: "woven_count_weft",
	editable: true,
	data_type: datatypes.STRING.key,
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: true, DISPLAY: true },
};

export const weightUnitDropdowns = [
	{ name: "GSM", key: "GSM" },
	{ name: "GLM", key: "GLM" },
	{ name: "GG", key: "GG" },
	{ name: "OZ", key: "OZ" },
];
export const weightColumn = {
	name: "Weight",
	key: "weight",
	editable: true,
	data_type: datatypes.STRING.key,
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: true, DISPLAY: true },
};

export const blendTypeDropdowns = [
	{ name: "COTTON", key: "COTTON" },
	{ name: "VISCOSE", key: "VISCOSE" },
	{ name: "POLYESTER", key: "POLYESTER" },
	{ name: "LYOCELL", key: "LYOCELL" },
	{ name: "NYLON", key: "NYLON" },
	{ name: "TENCEL", key: "TENCEL" },
	{ name: "WOOL", key: "WOOL" },
	{ name: "SPANDEX", key: "SPANDEX" },
	{ name: "BAMBOO", key: "BAMBOO" },
	{ name: "LINEN", key: "LINEN" },
	{ name: "DELAVE LINEN", key: "DELAVE LINEN" },
	{ name: "EXCEL", key: "EXCEL" },
	{ name: "MODAL", key: "MODAL" },
	{ name: "POLYAMIDE", key: "POLYAMIDE" },
	{ name: "LYCRA", key: "LYCRA" },
	{ name: "ELASTANE", key: "ELASTANE" },
	{ name: "METALLIC", key: "METALLIC" },
	{ name: "LUREX", key: "LUREX" },
	{ name: "ACRYLIC", key: "ACRYLIC" },
	{ name: "CASHMERE", key: "CASHMERE" },
	{ name: "ACETATE", key: "ACETATE" },
];
export const fabricNameDropdowns = [...blendTypeDropdowns, { name: "LYCRA PIQUE", key: "LYCRA PIQUE" }];

export const blendColumn = {
	name: "Blend",
	key: "blend",
	// editable: true,
	data_type: datatypes.STRING.key,
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: true, DISPLAY: true },
};

export const fabricFinalColumns = {
	fabric_code: {
		name: "Fabric Code",
		key: "fabric_code",
		input_type: inputTypes.AUTO_GENERATE.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	fabric_quality: {
		name: "Fabric Quality",
		key: "fabric_quality",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	fabric_blend: { ...blendColumn, key: "fabric_blend" },
	fabric_type: {
		name: "Fabric Type",
		key: "fabric_type",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	fabric_weave_knit: {
		name: "Weave/Knit",
		key: "fabric_weave_knit",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	fabric_sort_no: {
		name: "Fabric Sort No",
		key: "fabric_sort_no",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	fabric_name: {
		name: "Fabric Name",
		key: "fabric_name",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
};

export const constructionColumnsObj = {
	construction_warp: {
		name: "Const. WARP",
		key: "construction_warp",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	construction_weft: {
		name: "Const. WEFT",
		key: "construction_weft",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
};

export const calculateFabricFinalColumns = (data) => {
	let fabric_code = data?.fabric_code ? data?.fabric_code : "";
	let fabric_quality = "";
	let fabric_blend = "";
	let fabric_type = "";
	let fabric_weave_knit = "";
	let fabric_sort_no = "";
	let fabric_name = "";

	const weightFormat = `${data[weightColumn.key].split("_")[0]} ${data[weightColumn.key].split("_")[1] ?? ""}`;

	fabric_blend = data[blendColumn.key].split("_").join("%");
	fabric_type = `${data[fabricMasterColumnsObj.type.key]}, ${weightFormat}`;
	fabric_sort_no = data[fabricMasterColumnsObj.sort_no.key] ?? NAOption;

	// Calculate fabric_name based on highest blend percentage
	const blendParts = data[blendColumn.key].split(" ");
	let maxPercent = 0;
	let maxMaterial = "";
	for (const part of blendParts) {
		const [percent, material] = part.split("_");
		const percentNum = parseInt(percent) || 0;
		if (percentNum > maxPercent) {
			maxPercent = percentNum;
			maxMaterial = material;
		}
	}
	fabric_name = maxMaterial;
	if (data[fabricCategoryColumn.key] === fabricCategoriesObj.KNIT.key) {
		const knitCountFormatted = data[knitCountColumn.key]
			.split("+")
			.map((item) => {
				const [count, unit, ply] = item.split("_");
				return ply === "0" || !ply ? `${count}${unit}` : `${ply}/${count}${unit}`;
			})
			.join("+");
		fabric_quality = `${knitCountFormatted} ${weightFormat} ${data[fabricMasterColumnsObj.finish.key]} ${data[fabricMasterColumnsObj.weave_knit.key]} ${fabric_blend}`;
		fabric_weave_knit = `${data[fabricMasterColumnsObj.weave_knit.key]}, ${weightFormat}`;
	}
	if (data[fabricCategoryColumn.key] === fabricCategoriesObj.WOVEN.key) {
		const warpCountFormatted = data[wovencountWarpColumn.key]
			.split("+")
			.map((item) => {
				const [count, unit, ply] = item.split("_");
				return ply === "0" || !ply ? `${count}${unit}` : `${ply}/${count}${unit}`;
			})
			.join("+");
		const weftCountFormatted = data[wovencountweftColumn.key]
			.split("+")
			.map((item) => {
				const [count, unit, ply] = item.split("_");
				return ply === "0" || !ply ? `${count}${unit}` : `${ply}/${count}${unit}`;
			})
			.join("+");
		fabric_quality = `${warpCountFormatted}*${weftCountFormatted} ${data[constructionColumnsObj.construction_warp.key]}*${data[constructionColumnsObj.construction_weft.key]}, ${data[fabricMasterColumnsObj.finish.key]} ${data[fabricMasterColumnsObj.weave_knit.key]} ${fabric_blend}`;
		fabric_weave_knit = data[fabricMasterColumnsObj.weave_knit.key];
	}
	return { ...data, fabric_code, fabric_quality, fabric_blend, fabric_type, fabric_weave_knit, fabric_sort_no, fabric_name };
};
